var identity = identity || {};
identity.debug = true;
identity.initOnDocumentReady = function () {
    if(Object.hasOwn(identity, 'extranet')){
        identity.extranet.init();
    }
    if(Object.hasOwn(identity, 'campaign')){
        identity.campaign.init();
    }
    identity.ecom.init();
    identity.cart.init();
    //identity.checkout.init();
    identity.stockValidation.init();
    identity.datepicker();
    identity.bootstrap.init();
    identity.globalSearch.init();
    identity.quotes.updatePendingRequests();
};
identity.initOnWindowLoad = function () {
    identity.extensions.media();
    identity.paragraphVideo.init();
    identity.renderContent.init();
    identity.activeCampaign.init();
    identity.deferImages.init();
    identity.presenterMode.init();
    e4.breadcrumb.hideBreadcrumbsOnProductPage(jQuery('.js-e-breadcrumb'));
};

identity.extensions = {
    media: () =>{
        Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
            get: function(){
                return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
            }
        })
    }
}

identity.bootstrap = {
    init: () => {
        jQuery(document).on('show.bs.collapse hide.bs.collapse', '.no-animation', function(event) {
            event.preventDefault();
        });
        jQuery(document).on('click', '[data-toggle="collapse"].no-animation', function(event) {
            event.preventDefault();
            const strDataTarget = jQuery(event.target).data('target');
            const strHref = jQuery(event.target).attr('href');
            const strTarget = strDataTarget ? strDataTarget : strHref;
            jQuery(strTarget).toggleClass('show');
        })
    }
}

identity.globalSearch = {
    init: () =>{
        identity.globalSearch.bindEvents();
    },
    bindEvents: () =>{
        jQuery('#collapseHeaderSearch').on('shown.bs.collapse', (event) =>{
            const jSearchInput = jQuery(event.target).find('input');
            setTimeout(() =>{
                jSearchInput.trigger('focus');
            }, 1);
        });
    }
};

identity.quotes = {
    updatePendingRequests: () =>{
        document.addEventListener('identity:quote:statusChanged', (event) =>{
            const badge = document.querySelector('.js-identity-pending-quotes-count');
            const count = parseInt(event.detail);
            if(badge !== null){
                badge.textContent = count.toString();
                if(count > 0){
                    badge.classList.remove('d-none');
                } else{
                    badge.classList.add('d-none');
                }
            }
        });
        
    }
}


identity.presenterMode = {
    init: function () {
        identity.presenterMode.bindEvents();
    },
    bindEvents: function () {
        jQuery(document).on('change', '.js-identity-toggle-presenter-mode-input', function (event) {
            identity.presenterMode.toggleMode(event.target.checked);
        });
    },
    toggleMode: function (boolIsChecked) {
        jQuery.ajax({
            url: location.href,
            beforeSend: function () {
                jQuery('.js-identity-toggle-presenter-mode-spinner').removeClass('d-none');
            },
            data: {
                TogglePresenterMode: boolIsChecked
            }
        }).done(function () {
            location.reload();
        });
    }
};

identity.datepicker = function () {
    var strLang = jQuery('html').attr('lang'),
        defaultOpts = {
            language: strLang,
            format: 'dd-mm-yyyy',
            autoclose: true
        },
        jDatepickers = jQuery('.js-datepicker');

    if (jDatepickers.length > 0) {
        e4.require.js(e4.settings.require.datepicker, function () {

            jQuery.getScript('/Files/Templates/Designs/identity_v2/_assets/js/vendor/locales/bootstrap-datepicker.' + strLang + '.js', function () {
                jDatepickers.each(function (index, domDatepicker) {
                    var jDatepicker = jQuery(domDatepicker),
                        objExtendOpts = {
                            format: jDatepicker.data('date-format') || defaultOpts.format,
                            startDate: jDatepicker.data('start-date')
                        },
                        datePickerOpts = jQuery.extend({}, defaultOpts, objExtendOpts);

                    jDatepicker.datepicker(datePickerOpts).on('click', 'input', function () {
                        jDatepicker.datepicker('show');
                    });
                });
            });
        });
    }
};

identity.paragraphVideo = {
    init: function () {
        identity.paragraphVideo.playOnLoad();
        identity.paragraphVideo.playWhenVisible();
        identity.paragraphVideo.bindEvents();
        identity.paragraphVideo.play();
    },
    fit: function () {
        var jVideo = jQuery('.js-idd-p-video-movie');
        if (jVideo.length > 0) {
            objectFitPolyfill(jVideo);
        }
    },
    bindEvents: function () {
        identity.paragraphVideo.isRAF = false;
        jQuery(window).on('scroll resize', function () {
            if (identity.paragraphVideo.isRAF === false) {
                window.requestAnimationFrame(function () {
                    identity.paragraphVideo.playWhenVisible();
                    identity.paragraphVideo.isRAF = false;
                });
            }
            identity.paragraphVideo.isRAF = true;
        });
    },
    playWhenVisible: function () {
        var jParagraphVideo = jQuery('.js-idd-paragraph-video').filter('.play-in-viewport');
        jParagraphVideo.each(function () {
            var jThis = jQuery(this);
            if (e4.util.isInViewport(jThis) === true) {
                jThis.removeClass('play-in-viewport');
                jThis.find('.js-idd-p-video-movie').get(0).play();
            }
        });
    },
    playOnLoad: function () {
        var jParagraphVideo = jQuery('.js-idd-paragraph-video').not('.play-in-viewport');
        jParagraphVideo.each(function () {
            jQuery(this).find('.js-idd-p-video-movie').get(0).play();
        });
    },
    play: function () {
        var jVideo = jQuery('.js-idd-p-video-movie');
        if (jVideo.length > 0) {
            jVideo.addClass('is-ready');
            jVideo.get(0).play();
        }
    }
};
identity.renderContent = {
    init: function () {
        var jPageContentElements = jQuery('.js-render-page-content'),
            jParagraphContentElements = jQuery('.js-render-paragraph-content'),
            jModalAsyncContent = jQuery('.js-render-page-content-async-on-modal');
        if (jPageContentElements.length > 0) {
            jPageContentElements.each(function (index, domElm) {
                if (parseInt(domElm.dataset.pageId) > 0) {
                    identity.renderContent.getPage(domElm.dataset.pageId).done(function (pageHtml) {
                        var htmlContent = jQuery(pageHtml).find('.js-e-content .e-content-article').html();
                        jQuery(domElm).replaceWith(htmlContent);
                        identity.deferImages.init();
                    });
                } else {
                    jQuery(domElm).replaceWith('');
                }

            });
        }

        if (jParagraphContentElements.length > 0) {
            var _pageCache = {};
            jParagraphContentElements.each(function (index, domElm) {
                var pageParagraphIds = domElm.dataset.pageParagraphId;
                if (pageParagraphIds !== '') {
                    var splitId = pageParagraphIds.toLowerCase().replace('default.aspx?id=', '').split('#'),
                        pageId = splitId[0],
                        paragraphId = splitId[1];
                    if (jQuery.isEmptyObject(_pageCache) || _pageCache[pageId] === undefined) {
                        _pageCache[pageId] = [];
                    }
                    _pageCache[pageId].push({
                        paragraphId: paragraphId,
                        domElm: domElm
                    });
                } else {
                    jQuery(domElm).replaceWith('');
                }
            });
            Object.keys(_pageCache).forEach(function (_pageCacheKey) {
                identity.renderContent.getPage(_pageCacheKey).done(function (pageHtml) {
                    _pageCache[_pageCacheKey].forEach(function (paragraphObj) {
                        identity.renderContent.compileParagraph(paragraphObj.domElm, pageHtml, paragraphObj.paragraphId);
                    });
                });
            });
        }

        jModalAsyncContent.on('show.bs.modal', (event) =>{
            const jModalContentElement = jQuery(event.target).find('.js-render-page-content-async');

            if (parseInt(jModalContentElement.data('pageId')) > 0) {
                identity.renderContent.getPage(jModalContentElement.data('pageId')).done(function (pageHtml) {
                    var htmlContent = jQuery(pageHtml).find('.js-e-content .e-content-article').html();
                    jModalContentElement.replaceWith(htmlContent);
                    identity.deferImages.init();
                });
            } else {
                jModalContentElement.replaceWith('');
            }
        })
    },
    compileParagraph: function (domElm, pageHtml, paragraphId) {
        var htmlContent = jQuery(pageHtml).find('[id="' + paragraphId + '"]');
        jQuery(domElm).replaceWith(htmlContent);
        identity.deferImages.init();
    },
    getPage: function (pageId) {
        return jQuery.ajax({
            url: '/default.aspx?ID=' + pageId + '&Redirect=false',
            method: 'GET',
            dataType: 'html'
        });
    }
};